{
  const TOC_INSERT_SELECTOR = '#toc';
  const HEADING_SELECTOR = 'h1,h2,h3,h4,h5,h6';
  const LINK_CLASS_NAME = 'tocLink';
  const ID_NAME = 'heading';
  const tocInsertElement = document.querySelector(TOC_INSERT_SELECTOR);
  const tocTarget = document.querySelector('#toc_target');
  const headingElements = tocTarget.querySelectorAll(HEADING_SELECTOR);
  const layer = [];
  let id = 0;
  const uid   = () =>`${ID_NAME}${id++}`;
  let oldRank = -1;
  try {
      const createLink = (el) => {
          let li = document.createElement('li');
          let a  = document.createElement('a');
          el.id  = el.id || uid();
          a.href = `#${el.id}`;
          a.innerText = el.innerText;
          a.className = LINK_CLASS_NAME;
          li.appendChild(a);
          return li;
      };
      const findParentElement = (layer, rank, diff) => {
          do {
              rank += diff;
              if (layer[rank]) return layer[rank];
          } while (0 < rank && rank < 7);
          return false;
      };
      const appendToc = (el, toc) => {
          el.appendChild(toc.cloneNode(true));
      };
      headingElements.forEach( (el) => {
          let rank   = Number(el.tagName.substring(1));
          let parent = findParentElement(layer, rank, -1);
          if (oldRank > rank) layer.length = rank + 1;
          if (!layer[rank]) {
              layer[rank] = document.createElement('ol');
              if (parent.lastChild) parent.lastChild.appendChild(layer[rank]);
          }
          layer[rank].appendChild(createLink(el));
          oldRank = rank;
      });
      if (layer.length) appendToc(tocInsertElement, findParentElement(layer, 0, 1));
  } catch (e) {
      console.log("error");
  }
}

// ”目次”を追加
const toc = document.getElementById('toc')
if(toc.innerHTML){
  toc.insertAdjacentHTML('afterbegin', '<div class="toc-title">- 目次 -</div>');
}

// 高さの調整
var headH = $("header").outerHeight();
var barH = $("#shopify-section-announcement-bar").outerHeight();
var animeSpeed = 100;
$("a[href^='#']").on({
    "click": function () {
        var href = $(this).attr("href");
        var target = $(href == "#" || href === "" ? "html" : href);
        var position;
        position = target.offset().top - headH - barH;
        $('body,html').animate({scrollTop: position}, animeSpeed, 'swing');
        return false;
    }
});
